import { render } from "./HeroSideBar.vue?vue&type=template&id=6a1a3131&scoped=true"
import script from "./HeroSideBar.vue?vue&type=script&lang=js"
export * from "./HeroSideBar.vue?vue&type=script&lang=js"

import "./HeroSideBar.vue?vue&type=style&index=0&id=6a1a3131&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1a3131"]])

export default __exports__